import { render, staticRenderFns } from "./PendientesPago.vue?vue&type=template&id=bca65c9c&scoped=true&"
import script from "./PendientesPago.vue?vue&type=script&lang=js&"
export * from "./PendientesPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca65c9c",
  null
  
)

export default component.exports